import { InputGroup } from 'react-bootstrap';
import { useState, useEffect, useRef, useMemo, lazy, Suspense } from 'react';
import ToolTip from '../ToolTip/Tooltip';
import { GridView } from '../GridView/GridView';
import IconButton from '../IconButton/IconButton';
import useExceptionHandler from '../../Hooks/useExceptionHandler';
import usePaginationValuesWhere from '../../Hooks/usePaginationValuesWhere';
import { AnimatedIconButton } from '../AnimatedIconButton/AnimatedIconButton';
import { SvgComponent } from '../SvgComponent/SvgComponent';
import {BUSCAR_POR_RNC, BUSCAR_RNC, DEFAULT_PAGINATION_VALUES} from '../../Utils';
import SuspenseCRM from '../Suspense/SuspenseCRM';
import "./Lookup.style.css";
import {   
  buttonStyle,
  controlsProportion,
  initialWhere,
  initialWhereModal, } from '.';
import { AutoComplete } from '../AutoComplete/AutoComplete';
import {Simplebar} from "../Simplebar/Simplebar";

export const RncLookup = ({
  initialValue = { label: "", value: "" },
  onChange,
  isDisabled,
  isInput = false,
  style = {}, 
  placement,
    required = false
}) => {
  const DEFAULT_PAGINATION_VALUES = {
    EsPaginable: true,
    CantidadPorPagina: 15,
    EsOrdernable: true,
    OrderBy: "IdSec",
    EsAscendente: false,
  };

  const consultaActualId = useRef();
  const ref = useRef(null);
  const [showCanvas, setShowCanvas] = useState(false);
  const [rncListModal, setRncListModal] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    label: "",
    value: "",
    nombre: "",
  });
  const [whereModal, setWhereModal] = useState(initialWhereModal);
  const [pagination, setPagination] = useState({
    ...DEFAULT_PAGINATION_VALUES,
    Estatus: "",
    EsOrdernable: true,
    OrderBy: "Rnc1",
  });
  const { setPaginationValuesWhere } = usePaginationValuesWhere();

  useEffect(() => {
    if (whereModal != initialWhereModal) {
      buscar();
    }
  }, [whereModal]);

  useEffect(() => {
    if (
      selectedValue != undefined &&
      selectedValue.value !== null &&
      selectedValue.value != ""
    ) {
      onChange(selectedValue);
    }
  }, [selectedValue]);

  useEffect(() => {
    if (
      initialValue.value &&
      initialValue.value !== "" &&
      initialValue.value !== selectedValue.value
    ) {
      setValue();
    }
  }, [initialValue.value]);

  const buscar2 = (url, cuerpo) => {
    return new Promise(function (resolve, reject) {
      // eslint-disable-next-line no-undef
      Citrus.AJAX.getJSON(url, cuerpo, function (respuesta) {
        // eslint-disable-next-line no-undef
        var datos = $.parseJSON(respuesta.d);
        if (
          datos &&
          datos["Mensaje"] !== undefined &&
          datos["Detalle"] !== undefined &&
          datos["Interno"] !== undefined
        ) {
          reject(datos);
        }
        resolve(datos);
      });
    });
  };

  function buscar() {
    const whereWithPaginationValues = { ...whereModal, ...pagination };
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;
      const url = BUSCAR_RNC;
      buscar2(url, { where: {...whereWithPaginationValues} }).then((data) => {
        if (consultaId === consultaActualId.current) {
          setPaginationValuesWhere(data, pagination, setPagination);
          setRncListModal(data.Resultados);
        }
      });
    };
    obtenerDatos();
  }

  const setValue = () => {
    const obtenerDatos = () => {
      const consultaId = Math.random();
      consultaActualId.current = consultaId;
      const url = BUSCAR_POR_RNC;
      var documento = initialValue.value;
      buscar2(url, {documento}).then((data) => {
        if (consultaId === consultaActualId.current) {
          if(data.Resultados !== null){
            setSelectedValue({
              label: data.Resultados.Rnc1,
              value: data.Resultados.Rnc1,
              nombre: data.Resultados.RazonSocial,
            }); 
          }else{
            setSelectedValue({
              label: initialValue.value,
              value: initialValue.value,
            });
          }
        }
      });
    };
    obtenerDatos();
  };

  const handleCerrar = () => {
    setShowCanvas(false);
    setWhereModal(initialWhereModal);
  };

  const onPageIndexChanging = (pageNumber) => {
    setPagination((prevstate) => {
      return { ...prevstate, IndiceDePagina: pageNumber - 1 };
    });
    setWhereModal({ ...whereModal });
  };

    const getSuggestions = async (value) => {
      const inputValue = value.trim().toLowerCase();
      let resp;
        const consultaId = Math.random();
        consultaActualId.current = consultaId;
        const url = BUSCAR_RNC;
        await buscar2(url, { where: {...initialWhere, Criterio: inputValue} }).then((data) => {
          if (consultaId === consultaActualId.current) {
            resp = data.Resultados;
          }
        });
      return resp;
    };

  return (
    <>
      {!isInput ? (
        <InputGroup>
          <div style={{ width: controlsProportion.input }}>
            <AutoComplete
                required={required}
                placeholder="RNC"
              getList={getSuggestions}
              parentValue={selectedValue}
              setParentValue={setSelectedValue}
              noBorderRadius={isInput}
              isDisabled={isDisabled}
              noFilterSuggested={true}
              esDocumento={true}
            />
          </div>
          <div style={{ width: controlsProportion.button }}>
            <AnimatedIconButton
              size="40px"
              height="18"
              width="18"
              useVendorTheme
              message="Seleccionar RNC"
              style={buttonStyle}
              disabled={isDisabled}
              iconName="search"
              onClick={() => {
                setShowCanvas(true);
                setTimeout(() => {
                  buscar();
                }, 200);
              }}
            />
          </div>
        </InputGroup>
      ) : (
        <InputGroup>
          <div style={{ width: controlsProportion.inputGroup }}>
            <AutoComplete
                required={required}
                
              placeholder="RNC"
              getList={getSuggestions}
              parentValue={selectedValue}
              setParentValue={setSelectedValue}
              noBorderRadius={isInput}
              isDisabled={isDisabled}
              noFilterSuggested={true}
              esDocumento={true}
            />
          </div>
          <div style={{ width: controlsProportion.button }}>
            <AnimatedIconButton
              size="40px"
              height="18"
              width="18"
              message="Seleccionar RNC"
              style={buttonStyle}
              disabled={isDisabled}
              iconName="search"
              useVendorTheme
              onClick={() => {
                setShowCanvas(true);
                setTimeout(() => {
                  buscar();
                }, 200);
              }}
            />
          </div>
        </InputGroup>
      )}
      {showCanvas && (
        <Suspense>
          <Simplebar
            backdrop={true}
            ref={ref}
            placement={placement}
            portal={false}
            size="lg"
            useLoading={true}
            visible={showCanvas}
            setShow={(e) => {
              setShowCanvas(e);
            }}
            title="Seleccionar RNC"
            btnLeft={{
              show: false,
              func: () => {},
            }}
            btnRight={{
              show: false,
              func: () => {},
            }}
            useVendorTheme
          >
            <GridView
              pagination={pagination}
              setPagination={setPagination}
              allowPaging={pagination.EsPaginable}
              pageSize={pagination.CantidadPorPagina}
              pageIndex={pagination.IndiceDePagina}
              lastPageNumber={pagination.PaginasTotal}
              dataSource={rncListModal}
              onPageIndexChanging={onPageIndexChanging}
              where={whereModal}
              setWhere={setWhereModal}
            >
              <GridView.Column
                isSticky
                bodyRenderer={(row) => {
                  return (
                    <div className="float-right">
                      <IconButton
                        onClick={() => {
                          setSelectedValue({
                            label: row.Rnc1,
                            value: row.Rnc1,
                            nombre: row.RazonSocial,
                          });
                          handleCerrar();
                        }}
                      >
                        <ToolTip message="Seleccionar">
                          <div>
                            <SvgComponent
                              height="20"
                              width="20"
                              iconName="check"
                              fill="#f16101"
                            />
                          </div>
                        </ToolTip>
                      </IconButton>
                    </div>
                  );
                }}
              />
              <GridView.Column
                headerText="Razon Social"
                dataField="RazonSocial"
                sortExpression="RazonSocial"
              />
              <GridView.Column
                headerText="Rnc"
                dataField="Rnc1"
                sortExpression="Rnc"
                searchField="RncStr"
              />
            </GridView>
          </Simplebar>
        </Suspense>
      )}
    </>
  );
}
